import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { BookingsSection } from '@components/Home/BookingsSection';
import { DEFAULT_NUMBER_OF_BOOKINGS_SHOWN } from '@components/Home/constants';
import { NoddiCircularLoaderWithTrans } from '@components/Loading/NoddiCircularLoaderWithTrans';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useState } from 'react';
import { useBookingUserGroupId } from '../../../hooks/useBookingUserGroupId';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';

export const PreviousBookings = ({ userGroupId }: { userGroupId: number }) => {
  const [showAllBookings, setShowAllBookings] = useState(false);
  const { currentBrand } = useCurrentBrand();
  const { bookingUserGroupId, isReady, error: bookingUserGroupError } = useBookingUserGroupId(userGroupId);

  const { isPending, data, error } = noddiAsync.useGet({
    type: URLKeys.getPaginatedBookingsForCustomer,
    input: {
      userGroupId: bookingUserGroupId,
      isCompleted: true,
      pageSize: showAllBookings ? 1000 : DEFAULT_NUMBER_OF_BOOKINGS_SHOWN,
      pageIndex: 0,
      brandDomains: [currentBrand]
    },
    queryConfig: { enabled: isReady }
  });

  if (bookingUserGroupError) {
    return <ApiErrorPageWithTrans error={bookingUserGroupError} />;
  }
  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  if (!isReady || isPending) {
    return <NoddiCircularLoaderWithTrans />;
  }

  return (
    <BookingsSection
      bookingsPaginated={data}
      showAllBookings={showAllBookings}
      setShowAllBookings={setShowAllBookings}
    />
  );
};
